import { formatDate } from 'app/utils';
import { Button, Editor, Flex, Input, RichContent, Typography } from 'components';
import SelectTag from 'components/select2';
import { useAlert } from 'features/alert';
import { useAuth } from 'features/auth';
import { useState } from 'react';
import { ActionMeta, components, DropdownIndicatorProps, OnChangeValue } from 'react-select';
import { MessageItemProps } from '../messageCard/MessageCard';

export interface answerItem {
  sender: string;
  date: string;
  text: string;
}

export interface OptionProps {
  label: string;
  value: string;
}

export interface OptionValuesProps {
  name: string;
  uuid: string;
}

interface messageInboxProps {
  message?: MessageItemProps;
  tab?: string;
  onSentMessage: (newMessage: MessageItemProps) => void;
  onSentMessageAnswer: (newMessageAnswer: answerItem, uuid: string) => void;
}

const MessageInbox = ({ message, tab, onSentMessage, onSentMessageAnswer }: messageInboxProps) => {
  const [defaultValues, setDefaultValues] = useState<OptionValuesProps[]>([]);
  const [newSubject, setNewSubject] = useState('');
  const [newText, setNewText] = useState('');
  const dateNow = new Date();
  const { setAlert } = useAlert();

  const { fullName } = useAuth();

  const teachers = [{ uuid: '123456', name: 'Prof. Carlos Henrique' }];

  const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
      <components.DropdownIndicator {...props}>
        <Typography>...</Typography>
      </components.DropdownIndicator>
    );
  };

  const onChange = (newValue: OnChangeValue<OptionProps, true>, actionMeta: ActionMeta<any>) => {
    switch (actionMeta.action) {
      case 'remove-value':
      case 'pop-value':
        if (actionMeta.removedValue.isFixed) {
          return;
        }
        break;
      case 'clear':
        newValue = [];
        break;
    }

    if (newValue) {
      setDefaultValues(
        newValue.map((obj) => ({
          uuid: obj?.value,
          name: obj?.label,
        }))
      );
    }
  };

  function sendMessage() {
    tab === 'new' || !message
      ? defaultValues.map((item) =>
          onSentMessage({
            uuid: Math.random().toString(),
            title: item.name,
            text: newText,
            sender: fullName,
            subjects: newSubject,
            status: 1,
            isDelete: false,
            isAchive: false,
            isResponded: false,
            date: formatDate(dateNow).format('YYYY-MM-DDTHH:mm:ssZ'),
            answer: null,
            type: 'sent',
          })
        )
      : onSentMessageAnswer(
          {
            sender: fullName,
            date: formatDate(dateNow).format('YYYY-MM-DDTHH:mm:ssZ'),
            text: newText,
          },
          message.uuid
        );

    setAlert({
      type: 'success',
      message: 'E-mail enviado com sucesso!',
    });
    setNewText('');
    setNewSubject('');
    setDefaultValues([]);
  }

  return (
    <Flex flexDirection="column" p={6} overflow="auto" flexGrow={0}>
      {tab === 'new' || !message ? (
        <Flex flex={1} mb={4} flexDirection="column" flexGrow={0}>
          <Flex flex={1} mb={4}>
            <SelectTag
              id="sent"
              name="sent"
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              options={teachers.map((obj) => {
                return { value: obj.uuid, label: obj.name };
              })}
              closeMenuOnSelect={false}
              isSearchable
              onChange={onChange as any}
              value={defaultValues.map((obj) => {
                return { value: obj.uuid, label: obj.name };
              })}
              placeholder="Para:"
              components={{ DropdownIndicator }}
            />
          </Flex>

          <Input placeholder="Assunto:" value={newSubject} onChange={(e) => setNewSubject(e.target.value)} width="100%" />
        </Flex>
      ) : (
        <>
          <Flex borderBottomWidth={1} borderBottomStyle="solid" borderBottomColor="gray_100" justifyContent="space-between" flexGrow={0}>
            <Flex flexDirection="column" pb={4}>
              <Typography color="primary_400" type="type1" mb={2} fontWeight={600}>
                {message.subjects}
              </Typography>
              <Typography color="black" type="type2" fontWeight={600}>
                {message.sender}
              </Typography>
            </Flex>
            <Typography color="gray_500" type="type2">
              {formatDate(message.date).format('DD/MM/YYYY [ás] HH:mm')}
            </Typography>
          </Flex>
          <Flex py={4} borderBottomWidth={1} borderBottomStyle="solid" borderBottomColor="gray_100" color="gray1">
            <RichContent defaultType="type1" currentTheme={'light'}>
              {message.text}
            </RichContent>
          </Flex>
          {message.answer ? (
            <>
              <Flex borderBottomWidth={1} borderBottomStyle="solid" borderBottomColor="gray_100" py={4} justifyContent="space-between">
                <Flex flexDirection="column" justifyContent="space-between">
                  <Typography color="primary_400" type="type1" upper fontWeight={600} mb={2}>
                    Resposta
                  </Typography>
                  <Typography color="black" type="type3" fontWeight={600}>
                    {message.answer.sender}
                  </Typography>
                </Flex>
                <Typography color="gray_500" type="type2">
                  {formatDate(message.answer.date).format('DD/MM/YYYY [ás] HH:mm')}
                </Typography>
              </Flex>
              <Flex py={4}>
                <RichContent defaultType="type1" currentTheme={'light'}>
                  {message.answer.text}
                </RichContent>
              </Flex>
            </>
          ) : null}
        </>
      )}

      <Flex flexGrow={0}>
        <Editor height={200} onChange={(value) => setNewText(value)} content={newText} />
        <Flex mt={4} justifyContent="flex-end" flex={1}>
          <Button
            border="2px solid"
            borderColor="primary_400"
            bg="primary_400"
            color="white"
            bgHover="primary_400"
            colorHover="white"
            mr={3}
            onClick={() => sendMessage()}
          >
            {tab === 'new' ? 'Enviar' : 'Responder'}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MessageInbox;
